import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface UnavailabilityAlertProps {
  // Server-computed map of reason id => operator-facing description
  // (Hardware.unavailabilityReasons). Empty when the unit is rentable.
  reasons: Record<string, string> | null | undefined;
  typeName: string | null | undefined;
}

export const UnavailabilityAlert = ({ reasons, typeName }: UnavailabilityAlertProps) => {
  // Sorted by reason id: the server does not guarantee map order.
  const entries = Object.entries(reasons ?? {}).sort(([a], [b]) => a.localeCompare(b));
  if (entries.length === 0) {
    return null;
  }
  // Accessory units (e.g. locks) always carry not_rentable, since their
  // hardware type never matches the system's rentable type. A permanent
  // "not available for rentals" banner on those units is noise, so suppress
  // it entirely here, matching how the page hides its Rental Availability
  // pill for the same units.
  if (entries.some(([key]) => key === 'not_rentable')) {
    return null;
  }
  return (
    <Alert severity="warning" icon={<ErrorOutlineIcon fontSize="inherit" />}>
      This {typeName || 'hardware'} is not available for rentals:
      <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
        {entries.map(([key, description]) => (
          <li key={key}>{String(description)}</li>
        ))}
      </Box>
    </Alert>
  );
};
